// 3rd
import { Model } from '@vuex-orm/core';

export default class Brand extends Model {
    static entity = 'brands';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            image: this.attr(null),
        }
    }
}
